import styled from 'styled-components';
import { DropMenu, GetColor } from 'venn-ui-kit';
import { useHasFF } from 'venn-utils';
import { cn } from '@/lib/utils';
import React from 'react';

export const IconButton = styled.button`
  i {
    font-size: 12px;
    color: ${GetColor.GreyScale.Grey40};
    :hover {
      color: ${GetColor.Primary.Dark};
      cursor: pointer;
    }
  }
`;

export const InputDropMenu = styled(DropMenu)`
  width: 210px;
` as typeof DropMenu;

export const PanelItem = ({ children, className }: React.PropsWithChildren<{ className?: string }>) => {
  const hasBlockAssignment = useHasFF('block_assignment_ff');

  return (
    <div
      className={cn(
        'border-b border-x-0 border-t-0 border-solid border-venn-grey-30',
        hasBlockAssignment ? 'p-0' : 'px-[10px] pt-[10px] pb-[20px]',
        className,
      )}
    >
      {children}
    </div>
  );
};
